import { UserButton } from "@clerk/clerk-react"

export default function NavbarDashboard() {
  return (
    <div className="h-[4.7rem] border-b bg-gray-50 flex justify-end items-center px-6 py-2 z-40">
      <UserButton />
    </div>
  )
}
